import {THEME} from '@wandb/weave/common/css/color.styles';
import * as globals from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  .routed-tab .ui.tabular.menu {
    padding: 0;
    background: none;
    border: none;
    margin-bottom: 24px;
    border-bottom: 1px solid ${THEME.border};
    overflow: visible;
    .item {
      border: none;
    }
    .item.active {
      border: 1px solid ${THEME.border};
      border-bottom: none;
      background: ${THEME.bgSurface};
      margin-bottom: -1px;
      padding-bottom: 12px;
    }
  }
`;

// TODO - move this into a EditableImage.styles.ts file
export const AvatarPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  i {
    font-size: 64px;
    color: ${THEME.textSecondary};
  }
`;
